<template>
    <div>
        <div class="search_header" v-show='initOver'>
            <div>
                <div class="search_fn">
                    <i class='icon1'></i>
                    <div class="search-item">
                    <form action="javascript:;">
                        <input type="search" ref='search' @focus="insinte" @blur="insintes" @keyup.13="searchFn" autocomplete="off" placeholder="请输入关键字" v-model="keyWord" autocapitalize="off">
                        <i class="icon2" v-show="showClear" @click="delWord"></i>
                    </form>
                    </div>
                </div>
                <span class='edit' @click='toEdit'>编辑</span>
            </div>
        </div>

        <div class='serchBox' v-show='serchlist.length>0' v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="50">
            <div class="cellList" v-for="(item,index) of serchlist" :key="index" @click="jumpDetails(item.file_type,item.id,item.category_id)">
                <div class="left" >
                    <p v-show='isEdit' class='iconCheck' :class="item.isCheck?'active':''" @click.stop='toChange(index)'></p>
                    <div class="leftDiv">
                        <img v-if="item.file_type==0" :src="item.thumbnail" alt="">
                        <img v-else-if="item.file_type==1"  src="@/assets/imgs/pdf.png" alt="">
                        <img v-else-if="item.file_type==2" class="lianjieImg"   src="@/assets/imgs/lianjie.png" alt="">
                        <img v-else :src="item.thumbnail" alt="">
                        <div v-if="item.file_type==3" class="bofang"  @click="getInfos(item.file_type,item.id)">
                            <img class="bofangImg" src="@/assets/imgs/bofang.png" alt="">
                        </div>
                    </div>
                    <div v-if="item.file_type==0" >
                        <div v-show="item.photos_cnt!=1" class="photos_cnt">{{item.photos_cnt}} 张</div>
                    </div>
                    
                </div>
                <div class="right">
                    <div class="rightTitle">  
                        <div class="title">
                                <p v-if="item.file_type==0 || item.file_type==1"  class="supTitle" v-html='ruleTitle(item.post_title)'></p>
                                <p v-else-if="item.file_type==2"   class="supTitle" v-html='ruleTitle(item.post_title)'></p>
                                <p  v-else class="supTitle" v-html='ruleTitle(item.post_title)'></p>
                        </div>
                    </div>
                    <div class="btColor">
                        <div>
                            <span>{{item.published_time | timeType}}</span>
                        </div>
                    </div>
                </div>
              </div>
            <div class="sline" v-show='serchlist.length>6'></div>
        </div>
        <div class='noData full' v-show='zhixingSearch&&serchlist.length==0'>
            <img v-if="pageType=='0'" class='img2' src="@/assets/imgs/null2.png" alt=""><img v-else class='img3' src="@/assets/imgs/null3.png" alt=""><span>暂无{{pageType=='0'?'收藏的记录':'浏览历史'}}~</span>
        </div>
        <div class="serchTool" v-show='isEdit'>
            <p @click='cancelAll'>一键清空</p>
            <p @click='deleteChecks'>删除</p>
        </div>
        <alertBox v-show='showAlert' :Message="alertMessage" @replaceChecked="replace_checked" @sureChecked="sure_checked"></alertbox>
    </div>
  
</template>

<script>
import { Indicator } from 'mint-ui';
import { mapActions } from 'vuex'
import alertBox from '@/components/common/alertBox.vue'
export default {
  data() {
    return {
        caozuo:0,
        showAlert: false,
      alertMessage: "",
      selectIds:[],
      selectArrs:[],
      isEdit:false,
      keyWord:'',
      busy:false,
      showClear:false,
      zhixingSearch:false,
      hasResult:false,
      initOver:false,
      icon:'@/assets/icon_search.png',
      serchlist:[],
      page:1,
      isShowTag:true,
      pageType:0

    };
  },
  components: {
    alertBox
  },
  created(){
      let type=this.$route.query.type
      this.pageType=type?type:0
      document.title=this.pageType=='0'?'我的收藏':'浏览历史'
  },
  methods:{
      ...mapActions([
        'getCollects',
        'deletCollects',
        'gethistorys',
        'deletHistorys',
        'getArticals',
        'setVideoMsg'
        ]),
      replace_checked() {
          this.showAlert=false
    },
// 1.初始化加载时，判断有没有数据
// 2.执行搜索时，判断有没有数据
    async loadMore() {
        Indicator.open({
            text: '加载中...',
            spinnerType: 'fading-circle'
        });
        this.busy = false;
        this.getChoulist()
    },
     ruleTitle(items) {
        let title = items;
        let rep = new RegExp(this.keyWord, "g");
        let resDtring = `<span style='color:#00878b;'>${this.keyWord}</span>`;
        return this.keyWord==''?title:title.replace(rep, resDtring);
    },
    jumpDetails(type,id,cid){
          if(type==0 || type==1){      //图片，pdf
              this.$router.push('/details?type='+type+'&id='+id)
          }else{  
             this.getInfos(type,id,cid)
          }
      },
      async getInfos(type,id,cid){
          let info=new Object()
          info.id=id
          let result=await this.getArticals(info)
          if(result.code=='1'){
              let res=result.data
              if(type=='2'){
                   var URL=res.source_path;
                var reg=/amp;/
                URL=URL.replace(reg,"");
                window.location.href=URL
              }else{
                this.setVideoMsg(res)
                this.$router.push("/list?id="+cid+"&"+"videoId="+id)
              }
             
          }
      },
    async getChoulist(){
        
      let info=new Object()
      info.keyword=this.keyWord
      info.page=this.page
      const result= this.pageType=='0'?await this.getCollects(info):await this.gethistorys(info)
      if(result.code=='1'){
        let res=result.data
        let curTag=this.pageType=='0'?res:res
        if(this.page=='1'){
            let keys=this.keyWord
            if(keys==''){
                this.initOver=curTag.length>0
            }else{
                this.initOver=true
            }
          
        }
        for(let item of res){
            item.isCheck=false
        }
          this.serchlist=[...this.serchlist,...curTag]
          this.page=this.page+1
          this.busy=curTag.length<10?true:false;

         
          this.hasResult=true
            this.zhixingSearch=true
        }else{
            if(this.page=='1'){
                let keys=this.keyWord
                if(keys==''){
                    this.initOver=this.serchlist.length>0
                }else{
                    this.initOver=true
                }
            
            }
            this.busy=true
            this.hasResult=true
            this.zhixingSearch=true
        }
        Indicator.close();
        
    },
    sure_checked() {
        this.deletShoucang(this.caozuo)
    },
    toChange(index){
          this.serchlist[index].isCheck=!this.serchlist[index].isCheck
          let currentId=this.pageType=='0'?this.serchlist[index].id:this.serchlist[index].record_id
          if(this.serchlist[index].isCheck){
              this.selectIds.push(currentId)
          }else{
              this.selectIds.splice(this.selectIds.findIndex(item => item === currentId), 1)
          }
      },
      toEdit(){
          this.isEdit=!this.isEdit
      },
      deleteChecks(){
          let msg=this.pageType=='0'?'收藏记录':'历史足迹'
          if(this.selectIds.length==0){
              this.$toast(`请选择要删除的${msg}`)
              return;
          }
          this.caozuo=1
          this.alertMessage=`确认要删除选中的${this.selectIds.length}条${msg}吗？`
          this.showAlert=true
          
      },
      cancelAll(){
          let msg=this.pageType=='0'?'收藏记录':'历史足迹'
          this.caozuo=0
          this.alertMessage=`确认要清空全部${msg}吗？`
          this.showAlert=true
      },
      async deletShoucang(type){
          this.zhixingSearch=false
          let info=new Object()
          info.id=this.selectIds
          info.is_all=type==0?1:0
          const result=this.pageType=='0'?await this.deletCollects(info):await this.deletHistorys(info)
          if(result.code=='1'){
              this.$toast('操作成功')
              this.showAlert=false
            this.page = 1;
            this.serchlist=[]
            this.isEdit=false
             this.getChoulist()
          }else{
              this.isEdit=false
              this.$toast('操作失败，请联系管理员')
          }
      },
    delWord(){
      this.showClear=false;
      this.keyWord='';
      this.zhixingSearch=false;
      this.serchlist=[];
    },
    searchFn(){
        this.$refs.search.blur();
        this.page=1;
        if(this.serchlist.length>0){
            this.zhixingSearch=false
        }
        this.serchlist=[];
        this.getChoulist();
    },
    insinte(){
        this.showClear=true;
        
    },
    insintes(){
      if(this.keyWord==''){
          this.showClear=false;
      }else{
          this.showClear=true;
      }
    },
    clearInput(){
        this.showSearch=false;
    }
  }

};
</script>
<style src="@/assets/search.css" scoped></style>
<style scoped>
.edit{
    font-size:13px;
    color:#00878b;
}
.serchTool{
    width:100%;
    background:#ffffff;
    box-shadow:0px -1px 2px 1px rgba(0,0,0,0.19);
    position:fixed;
    bottom:0;
    display:flex;
    justify-content:flex-start;
    align-items:center;
    max-width:640px;
}
.serchTool p{
    font-size:14px;
    width:50%;
    height:45px;
    display:flex;
    justify-content:center;
    align-items:center;
    color:#00878b;
}
.serchTool p:nth-child(2){
    font-size:15px;
    background:#00878b;
    color:#fff;
}

    
</style>


// WEBPACK FOOTER //
// src/components/collectlist.vue